import type { FC } from "react";
import type { CardThumbnailProvider } from "./index";

type Props = {
  provider: CardThumbnailProvider;
};

const ProviderLink: FC<Props> = ({ provider }) => {
  if (provider.link) return <>{provider.link}</>;
  return (
    <p className="text-center font-dm-sans text-[9px] font-semibold leading-3 text-white">
      {provider.name}
    </p>
  );
};

export default ProviderLink;
